// class Video - OLD {
//   constructor(settings) {
//     const videoComponents = document.querySelectorAll(settings.videoComponentSelector);

//     videoComponents.forEach(videoComponent => {
//       const button = videoComponent.querySelector(settings.videoButtonSelector);
//       const thumbnail = videoComponent.querySelector(settings.thumbnailSelector);
//       button.addEventListener('click', (e) => {
//         console.log("button");
//         const iframe = videoComponent.querySelector('iframe');
//         const video = videoComponent.querySelector('video');

//         this.stopAllVideos(videoComponents);

//         // html5 video element
//         if (video) {
//           video.play();
//         }
//         // iframe autoplay youtube + vimeo
//         else if (iframe.src) {
//           if (iframe.src.startsWith('https://player.vimeo.com/') && Vimeo && Vimeo.Player) {
//             videoComponent.player = new Vimeo.Player(iframe);
//           }

//           iframe.src = iframe.src + '?autoplay=1&mute=1';
//         }

//         button.style.display = 'none';
//         thumbnail.style.display = 'none';
//       });
//     });
//   }

//   stopAllVideos(videos) {
//     videos.forEach(videoComponent => {
//       const iframe = videoComponent.querySelector('iframe');
//       const video = videoComponent.querySelector('video');

//       if (video) {
//         // HTML5 video palyer
//         video.pause();
//       } else if (iframe && iframe.src) {
//         // youtube stop event
//         if (iframe.src.startsWith('https://youtube.com/')) {
//           iframe.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
//         }
//         // vimeo stop event
//         else if (iframe.src.startsWith('https://player.vimeo.com/')) {
//           if (videoComponent.player) {
//             videoComponent.player.pause();
//           }
//         }
//       }
//     })
//   }
// } export default Video;

// NEW with autoplay

class Video {
  constructor(settings) {
    const videoComponents = document.querySelectorAll(settings.videoComponentSelector);

    videoComponents.forEach(videoComponent => {
      const button = videoComponent.querySelector(settings.videoButtonSelector);
      const thumbnail = videoComponent.querySelector(settings.thumbnailSelector);

      button.addEventListener('click', () => {

        const iframe = videoComponent.querySelector('iframe');
        const video = videoComponent.querySelector('video');

        // Stop any other videos
        this.stopAllVideos(videoComponents);

        // HTML5 video
        if (video) {
          video.play();
        }

        // YouTube or Vimeo iframe
        else if (iframe && iframe.src) {
          // Remove existing query string (e.g., if already clicked once)
          let baseSrc = iframe.src.split('?')[0];

          // Build new URL with autoplay
          let autoplaySrc = baseSrc;

          if (baseSrc.includes('youtube.com')) {
            autoplaySrc += '?autoplay=1&enablejsapi=1'; // NOT muted
          } else if (baseSrc.includes('vimeo.com')) {
            autoplaySrc += '?autoplay=1'; // Vimeo autoplay (not muted)
          }

          iframe.src = autoplaySrc;

          // Setup Vimeo Player if needed
          if (baseSrc.includes('vimeo.com') && typeof Vimeo !== 'undefined' && Vimeo.Player) {
            videoComponent.player = new Vimeo.Player(iframe);
          }
        }

        // Hide button and thumbnail
        if (button) button.style.display = 'none';
        if (thumbnail) thumbnail.style.display = 'none';
      });
    });
  }

  stopAllVideos(videoComponents) {
    videoComponents.forEach(videoComponent => {
      const iframe = videoComponent.querySelector('iframe');
      const video = videoComponent.querySelector('video');

      // Pause HTML5 video
      if (video) {
        video.pause();
      }

      // Stop YouTube iframe
      else if (iframe && iframe.src.includes('youtube.com')) {
        iframe.contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          '*'
        );
      }

      // Stop Vimeo iframe
      else if (iframe && iframe.src.includes('vimeo.com')) {
        if (videoComponent.player) {
          videoComponent.player.pause();
        }
      }
    });
  }
}

export default Video;




